import type { StreamingInfoResponseDrm } from './streamingInfoResponseDrm';
import type { StreamingInfoResponseMediaInfo } from './streamingInfoResponseMediaInfo';
import type { StreamingInfoResponseQualitiesItem } from './streamingInfoResponseQualitiesItem';
import type { StreamingInfoResponseStatus } from './streamingInfoResponseStatus';
import type { StreamingInfoResponseSupportedDevicesItem } from './streamingInfoResponseSupportedDevicesItem';

export interface StreamingInfoResponse {
  /** DRM 정보 (있는 경우) */
  drm?: StreamingInfoResponseDrm;
  /** 전체 재생 시간 (초) */
  duration?: number;
  /** HLS 버전 */
  hlsVersion?: string;
  /** 미디어 파일 기본 정보 */
  mediaInfo?: StreamingInfoResponseMediaInfo;
  /** HLS 재생 목록 URL (m3u8) */
  playlistUrl?: string;
  /** 사용 가능한 품질 목록 */
  qualities?: StreamingInfoResponseQualitiesItem[];
  /** 각 세그먼트 재생 시간 (초) */
  segmentDuration?: number;
  /** 스트리밍 상태 */
  status?: StreamingInfoResponseStatus;
  /** 스트리밍 기본 URL */
  streamUrl?: string;
  /** 스트리밍을 지원하는 장치 목록 */
  supportedDevices?: StreamingInfoResponseSupportedDevicesItem[];
  /** 총 세그먼트 수 */
  totalSegments?: number;
}
